import React from 'react';
import { PageInfo, Product } from '../../../models';
import { Pagination } from '../../shared';
import ProductCard from './ProductCard';

interface ProductsCatalogProps {
  products: Product[];
  pageInfo: PageInfo;
  setPageInfo: React.Dispatch<React.SetStateAction<PageInfo>>;
  minPrice: number;
  maxPrice: number;
}

function ProductsCatalog({
  products,
  pageInfo,
  setPageInfo,
  minPrice,
  maxPrice,
}: ProductsCatalogProps) {
  if (products.length === 0) {
    return (
      <div className="w-full k min-h-screen my-10 flex flex-col">
        <span className="mx-auto text-neutral-600 text-xl">
          No se han conseguido resultados
        </span>
      </div>
    );
  }

  return (
    <div className="w-full min-h-screen flex flex-col justify-between">
      <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-y-10 gap-x-1 sm:gap-x-5">
        {products?.map((product) => (
          <ProductCard
            key={product?._id}
            product={product}
            minPrice={minPrice}
            maxPrice={maxPrice}
          />
        ))}
      </div>
      <Pagination
        pageInfo={pageInfo}
        setPageInfo={setPageInfo}
        type="algolia"
      />
    </div>
  );
}

export default ProductsCatalog;
